



































import { Component, Prop, Vue, Watch, Emit, Mixins } from 'vue-property-decorator';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import multiselect from 'vue-multiselect';
import { Mounted } from '../decorators';
import { EventBus, hasElements, TypeEventBus, getDateFromDateFormatApi, splitStringByIndex } from '../utils';
import { RootStoreHelper, NotificationStoreHelper } from '../../core/mixins';
import { FilterDateEvent, getDateByFormat, Method } from '../utils';
import { TypeFilterDate } from '../models';

@Component({
    components: {
        multiselect
    }
})
export default class DatePickerSingle extends Mixins(RootStoreHelper, NotificationStoreHelper) {
    // date: any = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
    dateFormatted: any = null;
    dateFormattedTextField: any = null;
    menu1: boolean = false;
    @Prop({ default: false }) outlinedInput: boolean;
    @Prop({ default: '' }) value: string;
    @Prop({ default: 'Fecha' }) label: string;
    @Prop({ default: '' }) placeholder: string;
    @Prop({ default: undefined }) heightInput: string | undefined;
    @Prop({ default: undefined }) widthInput: string | undefined;
    @Prop({ default: 'mdi-calendar' }) prependIcon: string | undefined;

    @Emit()
    inputEvent(value) {}

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    @Watch('value', { immediate: true, deep: true })
    observableValue(date) {
        if (date != null && date.indexOf('T') > -1) {
            date = splitStringByIndex(date, 0, 10);
        }
        this.setDate(date);
    }

    parseDate(date) {
        if (!date) return null;
        return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    }

    dateSelected(dateSelected) {
        this.setDate(dateSelected);
        this.menu1 = false;
        this.handleListenKey(true);
    }

    setDate(date) {
        this.assignDate(date);
    }

    assignDate(value) {
        this.dateFormatted = value;
        this.dateFormattedTextField = this.parseDate(value);
        this.$emit('date-selected', value);
    }
}
